import React from "react";
import HeavenlyBody from "./heavenlyBody";
import { routeCodes } from "../../config/routes";
import { getString } from "../../utilities";
import Billboard from "./billboard";
import MilkyWay from "../../../assets/img/milkyWay.svg";

export default function HomeNav() {
  return (
    <div className="home-nav-wrapper">
      <div className="home-nav">
        <img src={MilkyWay} className="milkyway" width="1405" height="480" alt="" />

        <Billboard />

        <div className="col left">
          <HeavenlyBody path={routeCodes.GAMES} styles={["sun"]}>
            <span>{getString("games.all.0")}</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}prek`} styles={["grade-planet", "pink"]}>
            <span>PRE-K</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}k`} styles={["grade-planet", "yellow"]}>
            <span>{getString("grades.title", ["K"])}</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}1`} styles={["grade-planet", "red"]}>
            <span>{getString("grades.title", ["1"])}</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}2`} styles={["grade-planet", "blue"]}>
            <span>{getString("grades.title", ["2"])}</span>
          </HeavenlyBody>
        </div>

        <div className="col middle">
          <HeavenlyBody path={`${routeCodes.GRADES}3`} styles={["grade-planet", "green"]}>
            <span>{getString("grades.title", ["3"])}</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}4`} styles={["grade-planet", "magenta"]}>
            <span>{getString("grades.title", ["4"])}</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}5`} styles={["grade-planet", "orange"]}>
            <span>{getString("grades.title", ["5"])}</span>
          </HeavenlyBody>
          <HeavenlyBody path={`${routeCodes.GRADES}6`} styles={["grade-planet", "cyan"]}>
            <span>{getString("grades.title", ["6+"])}</span>
          </HeavenlyBody>
        </div>

        <div className="col right">
          <HeavenlyBody path={routeCodes.PRINTABLES} styles={["printables-planet"]}>
            <span>{getString("printables.title.0")}</span>
          </HeavenlyBody>
        </div>
      </div>
    </div>
  );
}
